export default "__VITE_ASSET__C2Ja_P2D__"